import styled from '@emotion/styled'
// import tw from 'twin.macro'

const StyledMenuVertical = styled.div`
  transition: transform 450ms ease, width 500ms ease;
  width: ${(props) => {
    const { width, collapse, collapsedWidth } = props
    return collapse ? collapsedWidth : width
  }};
  min-width: ${(props) => {
    const { width, collapse, collapsedWidth } = props
    return collapse ? collapsedWidth : width
  }};
`

// 头部
const StyledMenuTitle = styled.div`
  padding: 14px 24px;
  border-bottom: 1px solid #57697e;
  display: flex;
  background: ${(props) => {
    const { backgroundColor } = props
    return backgroundColor || 'rgb(var(--ow-primary-color))'
  }};
  > div {
    display: flex;
    align-items: center;
  }
`

// 内容部分
const StyledMenuContent = styled.div`
  height: calc(100% - 49px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${(props) => {
    const { textColor } = props
    return textColor
  }};
  background: ${(props) => {
    const { backgroundColor } = props
    return backgroundColor || 'rgb(var(--ow-primary-color))'
  }};
  p {
    margin: 0;
  }
`

// 单个Nav Item
const StyledMenuContentNavItem = styled.div`
  .menu-first-level {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 22px;
    cursor: pointer;
    &:hover {
      .menu-name {
        color: ${(props) => {
          const { hoverFontColor } = props
          return hoverFontColor
        }};
      }
    }
    .menu-first-level-left {
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      height: ${(props) => {
        const { collapse } = props
        return !collapse ? 'auto' : '25.8px'
      }};
      .menu-name {
        display: inline-block;
        width: 180px;
        transition: all 500ms ease;
        font-size: ${({ theme }) => {
          return theme.fontSizes.md
        }};
        color: rgb(var(--ow-text-inverse-color));
      }
    }
  }
  .menu-vertical-nav-item-active {
    background: rgb(var(--ow-primary-color));
  }
`

// 单个Nav Item下的childrens
const StyledMenuContentNavItemChildren = styled.div`
  cursor: pointer;
  overflow: hidden;
  transition: all 500ms ease;
  > div {
    height: 33px;
    overflow: hidden;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    padding: 6px 40px 6px 38px;
    &:hover {
      color: ${(props) => {
        const { hoverFontColor } = props
        return hoverFontColor
      }};
    }
  }
  > div.menu-vertical-nav-child-item-active {
    color: ${(props) => {
      const { hoverFontColor } = props
      return hoverFontColor || 'rgb(var(--ow-primary-color))'
    }};
  }
`

export {
  StyledMenuVertical,
  StyledMenuTitle,
  StyledMenuContent,
  StyledMenuContentNavItem,
  StyledMenuContentNavItemChildren,
}
